import { useState, useCallback } from 'react';

export const useSet = (initalDataArr = []) => {
  const [set, setSet] = useState(() => new Set(initalDataArr));

  const makeOperation = useCallback((callback) => {
    setSet((currentSet) => {
      const newSet = new Set(currentSet);
      callback(newSet);
      return newSet;
    });
  }, []);

  return [set, makeOperation];
};
